import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router'
import useAuth from '../hooks/useAuth'
import AppRoutes from '../routes/appRoutes'

/*
 * Wrapper function for auth pages to be checked for existing maintenance mode session
 * BE SURE TO CHECK checkMaintenance.js for the non-authorized version of the same check if making updates.
 */
export default (ComposedComponent, allowedRoles, checkFunction) => {
    const RequireAuth = props => {
        const {
            history: { push },
            location: { pathname },
        } = props

        const { authenticated, role, impersonated } = useAuth()

        // Push to login route if not authenticated
        useEffect(() => {
            if (!authenticated) {
                // props.history.push = redirect to props.location.pathname
                push(AppRoutes.login('redirect=' + pathname))
            }
        }, [authenticated, pathname, push])

        // Check maintenance mode status (must not run during render — it updates Routes / misc state)
        useEffect(() => {
            checkFunction()
        }, [checkFunction])

        // Otherwise render the original component
        // const link = impersonated ? (
        //     <div className="impersonate-flag">
        //         <div className="row">
        //             <div className="columns small-7">
        //                 <div className="viewing">
        //                     <span className="show-for-medium">Now Viewing</span>{' '}
        //                     <em>
        //                         {user.first_name} {user.last_name}’s
        //                     </em>{' '}
        //                     account
        //                 </div>
        //             </div>
        //             <div className="columns small-5">
        //                 <span
        //                     className="back"
        //                     onClick={() => {
        //                         push(AppRoutes.logout()) // this doesn't seem to match the text...
        //                     }}
        //                 >
        //                     Back to Admin{' '}
        //                     <i className="icon-chevron-thin-right" />
        //                 </span>
        //             </div>
        //         </div>
        //     </div>
        // ) : role != 'admin' && role != 'salesperson' && user ? (
        //     <div className="whois-flag">
        //         <div className="row">
        //             <div className="columns small-7">
        //                 <div className="viewing">
        //                     <em>
        //                         {user.first_name} {user.last_name}
        //                     </em>
        //                 </div>
        //             </div>
        //             <div className="columns small-5">
        //                 <div className="company-name">
        //                     <span>{user.company ? user.company.name : ''}</span>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // ) : null

        return allowedRoles.includes(role) ? (
            <React.Fragment>
                <ComposedComponent {...props} />
            </React.Fragment>
        ) : impersonated ? (
            <Redirect to={AppRoutes.login()} /> //this is a not a final solution for impersonation redirects
        ) : (
            <Redirect to={AppRoutes.login('redirect=' + pathname)} />
        )
    }

    RequireAuth.propTypes = {
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
        }),
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
        }),
    }

    const connectedRequireAuth = RequireAuth

    return connectedRequireAuth
}
